// Round page: where a team's scorecard should land when scrolling snaps to it --
// just under the locked top of the Scorecards card. That block's height varies
// (title wrap, course rows), so measure it and publish the landing offset as
// --scorecards-snap-top (components.scss). Presentation only.
function syncScorecardSnap() {
  const top = document.querySelector('.faso-scorecards-top');
  const stack = document.querySelector('.faso-scorecard-stack');
  if (!top || !stack) return;

  const publish = () => {
    // Where the locked block sits (its sticky top), plus its own height.
    const stickyTop = parseFloat(getComputedStyle(top).top) || 0;
    stack.style.setProperty('--scorecards-snap-top', `${Math.round(stickyTop + top.offsetHeight)}px`);
  };
  publish();
  if (window.ResizeObserver && !top.dataset.snapObserved) {
    top.dataset.snapObserved = 'true';
    new ResizeObserver(publish).observe(top);
  }
}

document.addEventListener('turbolinks:load', syncScorecardSnap);

// Turbolinks caches the page with the flag set; clear it so a restored page
// re-attaches its observer.
document.addEventListener('turbolinks:before-cache', () => {
  const top = document.querySelector('.faso-scorecards-top');
  if (top) delete top.dataset.snapObserved;
});
